import { render, staticRenderFns } from "./register-update-info.vue?vue&type=template&id=ff5ff760"
import script from "./register-update-info.vue?vue&type=script&lang=js"
export * from "./register-update-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports